import React from "react";
import Title from "../../components/Title/Title";
import "./Contact.scss";
import ContactIfo from "./components/contactInfo/ContactIfo";
import ContactForm from "./components/contactForm/ContactForm";

const Contact = () => {
  return (
    <div className="page-container contact">
      <Title heading={"Contact"} />
      <div className="row contact-part">
        <div className="col-lg-8 col-sm-12">
          <ContactForm />
        </div>
        <div className="col-lg-4 col-sm-12">
          <ContactIfo />
        </div>
      </div>
    </div>
  );
};

export default Contact;
